var _path, _rect, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFailedPackage = function SvgFailedPackage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 130,
    viewBox: "0 0 203 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.25 7.44708H14.6776C12.5768 7.44708 10.8737 9.15018 10.8737 11.2511V68.2236V125.196C10.8737 127.297 12.5768 129 14.6776 129H198.25C200.351 129 202.054 127.297 202.054 125.196V11.2511C202.054 9.15018 200.351 7.44708 198.25 7.44708Z",
    fill: "#EB5757",
    stroke: "#AE2727",
    strokeWidth: 1.45388
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8376,
    y: 29.6824,
    width: 185.253,
    height: 23.7176,
    rx: 1.45388,
    fill: "#AE2727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1949 91.9412H22.7672C21.9281 91.9412 21.2478 92.6215 21.2478 93.4606C21.2478 94.2998 21.9281 94.98 22.7672 94.98H80.1949C81.034 94.98 81.7143 94.2998 81.7143 93.4606C81.7143 92.6215 81.034 91.9412 80.1949 91.9412Z",
    fill: "#AE2727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0783 101.058H22.7672C21.9281 101.058 21.2478 101.738 21.2478 102.577C21.2478 103.416 21.9281 104.097 22.7672 104.097H65.0783C65.9174 104.097 66.5977 103.416 66.5977 102.577C66.5977 101.738 65.9174 101.058 65.0783 101.058Z",
    fill: "#AE2727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1482 110.174H22.7672C21.9281 110.174 21.2478 110.854 21.2478 111.694C21.2478 112.533 21.9281 113.213 22.7672 113.213H74.1482C74.9874 113.213 75.6676 112.533 75.6676 111.694C75.6676 110.854 74.9874 110.174 74.1482 110.174Z",
    fill: "#AE2727"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.594,
    cy: 102.318,
    rx: 14.8202,
    ry: 14.8235,
    fill: "#AE2727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.824 118.384C188.696 118.384 195.887 111.191 195.887 102.318C195.887 93.4445 188.696 86.251 179.824 86.251C170.952 86.251 163.761 93.4445 163.761 102.318C163.761 111.191 170.952 118.384 179.824 118.384Z",
    fill: "#AE2727",
    stroke: "#EB5757",
    strokeWidth: 2.48626
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3989 55.9688C44.0374 55.9688 55.9034 44.0995 55.9034 29.4588C55.9034 14.8182 44.0374 2.94883 29.3989 2.94883C14.7604 2.94883 2.89439 14.8182 2.89439 29.4588C2.89439 44.0995 14.7604 55.9688 29.3989 55.9688Z",
    fill: "white",
    stroke: "#AE2727",
    strokeWidth: 4.10233
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4584 20.4583L29.5 29.5M29.5 29.5L38.5417 38.5417M29.5 29.5L38.5417 20.4583M29.5 29.5L20.4584 38.5417",
    stroke: "#AE2727",
    strokeWidth: 4.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailedPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/failed-package.f0014a3f.svg";
export { ForwardRef as ReactComponent };